import { parse } from 'tldts'

export type HostInfo = ReturnType<typeof parse>

const getHostInfo = (host: string = window.location.host) =>
    parse(host, { validHosts: ['localhost'] })

export default getHostInfo
